/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import actions from './moduleDataListActions.js'
import state from './moduleDataListState.js'
import mutations from './moduleDataListMutations.js'

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
